import { useSelector } from 'react-redux';
import { getAllTeams } from '../../../redux/teamRedux';
import styles from './Team.module.scss';
import ButtonBlue from '../../common/ButtonBlue/ButtonBlue';
import Button from '../../common/Button/Button';
import { useNavigate } from 'react-router-dom';
const Team = () => {
  const teams = useSelector(getAllTeams);
  const navigate = useNavigate();

  return (
    <div className={styles.team}>
      {/* title section */}
      <div>
        <h1 className={styles.title}>Nasz zespół</h1>
        <p className={styles.info}>
          Doświadczeni specjaliści pracujący interdyscyplinarnie, by zapewnić Ci
          pełne wsparcie i opiekę.
        </p>
      </div>
      {/* box section */}
      <div className={styles.boxTeam}>
        {teams.map((team) => (
          <article className={styles.box} key={team.id}>
            <div className={styles.header}>
              <div className={styles.initials}>{team.initials}</div>
              <div className={styles.infoName}>
                <h3>{team.name}</h3>
                <p>{team.specialize}</p>
              </div>
            </div>
            <p className={styles.description}>{team.description}</p>
            <ul className={styles.tags}>
              {team.tags.map((tag, index) => (
                <li key={index}>{tag}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>
      <div className={styles.boxSpecial}>
        <h1>Standardy pracy </h1>
        <p>
          Pracujemy w oparciu o najwyższe standardy, regularnie superwizując
          naszą pracę terapeutyczną i stale podnosząc nasze kompetencje
          zawodowe. Naszą pracę kieruje Kodeks Etyczny Psychologa i
          przestrzeganie tajemnicy zawodowej.
        </p>
      </div>
      <div className={styles.boxSpecial}>
        <h1>Jesteś zainteresowany terapią? </h1>
        <p>
          Dowiedz się więcej o specjalizacjach naszego zespołu i zarezerwuj
          wizytę.
        </p>

        <div className={styles.btn}>
          <ButtonBlue onCilck={() => navigate('/contact')}>
            {' '}
            Umów się{' '}
          </ButtonBlue>
          <Button onClick={() => navigate('/offers')}>Poznaj ofertę</Button>
        </div>
      </div>
    </div>
  );
};

export default Team;
